<template>

</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import CustomLocaleControl from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl';

import { ElButton, ElUpload, } from 'element-plus';
import SvgIcon from '@/components/SvgIcon';

import { uploadShootingLocationVideo } from '@/api/UserWorkspaceDataApi';
import {
  addShootingLocation, updateShootingLocation,
} from '@/api/ShootingLocationApi';

// Home自定义图层
import { saveGraphic, } from '@/api/UserDrawApi';
import { addRegionDirectory, } from '@/api/RegionDirectoryApi'

// props
const props = defineProps({

});
// emit
const emit = defineEmits([

]);

// 组件挂载前
onBeforeMount(() => {

});
// 组件挂载后
onMounted(() => {
  // mapEventInit();
  store.commit('isHomeCustomLayerChange', true);
  store.commit('isCustomLayerChange', true);
});
// 组件更新后
onUpdated(() => {

});
// 组件销毁后
onUnmounted(() => {
  layerGroupClose();
  mapEventClose();
  store.commit('isHomeCustomLayerChange', false);
  store.commit('isCustomLayerChange', false);
});

const homeMap = computed(() => store.getters['getHomeMap']),
  map = toRaw(homeMap.value),
  layerGroup = L.featureGroup().addTo(map),
  layerGroupClose = () => {
    map.removeLayer(layerGroup);
  },
  layerGroupClear = () => {
    layerGroup.clearLayers();
  }

const mapEventClose = () => {
  map.off(L.Draw.Event.DRAWSTOP);
}
const mapEventInit = () => {
  map.on(L.Draw.Event.DRAWSTOP, event => {
    // console.log(event);
    if (event.layerType == 'fileUpload') {
      fileUploadInit(event);
      return;
    }
    if (!event.layer) return;
    const layer = event.layer,
      bounds = layer.getBounds && layer.getBounds();
    layer.options['layerType'] = event['layerType'];
    // console.log(bounds, layer.getLatLngs());
    if (!bounds.isValid()) {
      message('无效区域', 2);
      return;
    }
    customLocaleControlInit(layer, {});
    layerGroup.addLayer(layer);
  })
}
const customLocaleControlInit = (layer, target) => {
  // console.log(layer);
  const bounds = layer.getBounds();
  const layerClick = (event) => {
    const icon = controlMarker && controlMarker._icon;
    if (!icon) return;
    const display = icon.style.display;
    if (display == 'none') {
      icon.style.display = 'unset';
    } else {
      icon.style.display = 'none';
    }
  }
  const app = vueCreateAppInit(CustomLocaleControl, {
    target,
    layer,
    onLayerDelete: () => {
      layerGroup.removeLayer(layer);
    },
    layerGroup: layerGroup,
    // workSpace: props.workSpace,
    layerClick,
  });

  const controlMarker = L.marker(bounds.getNorthEast(), {
    icon: L.divIcon({
      iconAnchor: [-5, 0],
    }),
    // interactive: false,
  }).on({
    remove: event => {
      app.unmount();
    }
  }).addTo(layerGroup);
  nextTick(() => {
    const icon = controlMarker._icon;
    if (icon) {
      icon.style.display = 'none';
      app.mount(icon);
    }
  })
  layer.on({
    remove: event => {
      layerGroup.removeLayer(controlMarker);
    }
  })

}

// 文件上传
const fileUploadCom = (marker) => {
  const { lat, lng } = marker.getLatLng();
  return defineComponent({
    setup() {
      const videoUrl = ref(undefined),
        videoName = ref(undefined),
        loading = ref(false),
        editId = ref(undefined),
        submitPort = computed(() => {
          return editId.value ? updateShootingLocation : addShootingLocation;
        })
      const slotContent = computed(() => {
        return videoUrl.value
          ? () => [
            h('video', {
              controls: false,
              style: { width: '200px', height: '120px' },
              src: videoUrl.value,
              autoplay: true,
              loop: true,
            }),
          ]
          : () => h(SvgIcon, {
            iconName: loading.value ? 'loading' : 'plus-box',
            fillColor: 'rgb(81, 177, 217)',
          })
      });
      return () => [
        h(ElUpload, {
          showFileList: false,
          autoUpload: false,
          action: '',
          accept: '.mp4',
          class: 'home-file-upload',
          onChange: (file, fileList) => {
            // console.log(file, fileList);
            loading.value = true;
            uploadShootingLocationVideo({
              file: file.raw,
            }).then(res => {
              if (res.data.code == 1004) {
                videoName.value = res.data.data['imageName'];
                videoUrl.value = res.data.data['data'];
              }
              loading.value = false;
            }).catch(err => {
              loading.value = false;
              console.log(err);
            });
          }
        }, {
          default: slotContent.value,
        }),
        h(ElButton, {
          size: 'small',
          type: 'primary',
          style: {
            width: '120px',
          },
          loading: loading.value,
          onClick: () => {
            if (!videoName.value) {
              message('请选择上传文件', 2);
              return
            }
            loading.value = true;
            const mapId = store.getters['workBenchMapId'];
            submitPort.value({
              id: editId.value,
              lat: lat,
              lon: lng,
              videoFileName: videoName.value,
              mapId,
            }).then(res => {
              if (res.data.code == 1004) {
                editId.value = res.data.data;
              }
              loading.value = false;
            }).catch(err => {
              loading.value = false;
              console.log(err);
            });
          }
        }, () => '上传文件')
      ]
    }
  })
}

const fileUploadInit = (event) => {
  const marker = event.layer;
  const app = vueCreateAppInit(fileUploadCom(marker));
  const popupopenFn = () => {
    let fn = (popupopen) => {
      const popup = popupopen.popup,
        popupEl = popup.getElement(),
        content = popupEl.querySelector('.leaflet-popup-content');
      // console.log(content);
      if (content) {
        app.mount(content)
      }
    }
    return (popupopen) => {
      fn(popupopen);
      fn = () => { }
    }
  }
  marker.on({
    popupopen: popupopenFn(),
  }).bindPopup(undefined, {
    closeButton: false,
    autoClose: false,
    direction: 'top',
    className: 'leaflet-popup-message home-file-popup-message',
  })

  layerGroup.addLayer(marker);
}

</script>

<style lang='less'>
.home-file-popup-message {
  .leaflet-popup-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }
}

.home-file-upload {
  display: flex;
  justify-content: center;
}
</style>

<style lang='less' scoped></style>